<template>
    <Loading v-bind:show="showLoading">
        <PageTitle title="Acordos" />
        <div v-if="!showLoading && $featureToggle && $featureToggle.INTEGRA_ACORDO_GRID">
            <div class="md-layout-item md-size-100" v-if="dadosAba">
                <GridAcordo v-bind:Data="dadosAba.acordos"
                      v-bind:Header="headerAcordo"
                      Name="Acordos"
                      Title="Total"
                      OrderBy="dataHoraGeracao"
                      v-bind:HeaderDetalhes="null"
                      v-bind:DetalhesCombo1="dadosAba.numeroAcordo"
                      v-bind:DetalhesCombo2="dadosAba.unidadeCobranca"
                      v-bind:DetalhesCombo3="null" />
            </div>

        </div>
    </Loading>
</template>
<script>
    import GridAcordo from '@/components/GridAcordo';
    import AcordoService from '@/services/AcordoService.js';
    import Loading from '@/components/Loading';
    import PageTitle from '@/components/PageTitle';

    export default {
        components: {
            GridAcordo,
            Loading,
            PageTitle
        },
        created() {
            //Verifica se tem aluno selecionado
            if (!sessionStorage.Aluno) {
                this.$router.push('home');
            }
            else {
                let a = JSON.parse(sessionStorage.Aluno);
                this.aluno = a.PerfilAluno;

                //Verifica se a aba ja está carregada
                if (this.aluno.Acordo) {
                    this.dadosAba = a.Acordo;
                }
                else {
                    if (this.$featureToggle.INTEGRA_ACORDO_GRID) {

                        this.acordoService = new AcordoService(this);

                        //Popula os dados da aba
                        this.showLoading = true;
                        this.acordoService.ListarAcordo({
                            Cpf: this.aluno.cpf
                        }).then(
                            data => {
                                if (data.ok) {
                                    console.log(data.dados.acordos);
                                    this.dadosAba = data.dados;
                                }
                                else {
                                    this.$modal.info(data.Mensagem);
                                }
                            },
                            error => {
                                if (error.status != 500)
                                    this.$modal.alert((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                                else
                                    this.$modal.error((error.body?.Mensagem || error?.response?.statusText || error.message), error.body?.Detalhe);
                            }).finally(() => {
                                this.showLoading = false;
                            });
                    }
                    else {
                        this.$modal.alert(this.$msgFeatureToggle);
                    }
                }
            }
        },
        beforeDestroy() {
            let aluno = JSON.parse(sessionStorage.Aluno);

            //Armazena os dados da aba pra nao precisar carregar novamente
            aluno.Acordo = this.dadosAba;
            sessionStorage.setItem("Aluno", JSON.stringify(aluno));
        },
        data() {
            return {
                aluno: null,
                dadosAba: null,
                showLoading: false,
                headerAcordo: [
                    {
                        Titulo: "Data Geração",
                        Field: "dataHoraGeracao",
                        Width: "100px",
                        Tipo: "date"
                    },
                    {
                        Titulo: "Número Acordo",
                        Field: "numeroAcordo",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Unidade Cobrança",
                        Field: "unidadeCobranca",
                        Width: "120px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Credor",
                        Field: "credor",
                        Width: "100px",
                        Tipo: "texto"
                    },
                    {
                        Titulo: "Valor",
                        Field: "valor",
                        Width: "100px",
                        Tipo: "moeda"
                    },
                    {
                        Titulo: "Status",
                        Field: "status",
                        Width: "100px",
                        Tipo: "texto"
                    }
                ]
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .md-field {
        max-width: 100%;
        font-weight: bold;
    }
</style>
